import React from "react";
import {useLocation, useParams} from "react-router-dom";

import PageHeader from "src/componets/PageHeader";
import NavBarTwo, { parentInterface } from "src/componets/NavBarTwo";
import NavBarThree from "src/componets/NavBarThree";
import Can from "src/componets/Can";
import {PlusOutlined, SettingOutlined} from "@ant-design/icons";
import { selectCategoryIds, setNewParams, setReorderIds } from "src/store/community/categoriesSlice";
import {
  selectKindIds,
  setNewParams as setNewKindParams,
  setReorderIds as setKindReorderIds
} from "src/store/community/kindsSlice";
import { useAppDispatch, useAppSelector } from "src/store/hooks";

interface PropsInterface {
  title: string;
  navs: {[index: number]: any};
  parent?: parentInterface;
  target: 'content' | 'community';
}

const _PageHeader = ({ title, navs, parent, target }: PropsInterface) => {
  const { pathname }  = useLocation();
  const dispatch = useAppDispatch();
  const activeItem    = Object.values(navs).find(e => e.url === pathname || (e.isActive && e.isActive()));
  const ids = useAppSelector(selectCategoryIds);
  const kindIds = useAppSelector(selectKindIds);
  const { app_id } = useParams();

  function onClickCreate() {
    dispatch(setNewParams({ app_id: app_id, target: target }));
  }

  function onClickSettings() {
    dispatch(setReorderIds({ ids }));
  }

  function onClickCreateKind() {
    dispatch(setNewKindParams({ app_id: app_id, target: target }));
  }

  function onClickKindSettings() {
    dispatch(setKindReorderIds({ ids: kindIds }));
  }


  return (
    <PageHeader
      title={title}
      breadcrumbs={[activeItem?.name]}
    >
      <NavBarTwo
        items={navs}
        itemIds={Object.keys(navs)}
        activeId={activeItem?.id}
        parent={parent}
      />

      <Can capability='write_community'>
        <NavBarThree>
          <NavBarThree.Button onClick={onClickKindSettings}>
            <SettingOutlined /> Kind Settings
          </NavBarThree.Button>
          <NavBarThree.Button onClick={onClickCreateKind}>
            <PlusOutlined /> Create Kind
          </NavBarThree.Button>
          <NavBarThree.Button onClick={onClickSettings}>
            <SettingOutlined /> Category Settings
          </NavBarThree.Button>
          <NavBarThree.Button onClick={onClickCreate}>
            <PlusOutlined /> Create Category
          </NavBarThree.Button>
        </NavBarThree>
      </Can>
    </PageHeader>
  );
}

export default _PageHeader;
